import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const FutbolCard = styled.section`
  margin-left: calc((100% - 898px - 1rem) / 2);
  max-width: 600px;
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 40px;
  ${breakpoints.phone} {
    margin: auto;
    margin-bottom: 40px;
    width: 100%;
  }
  .futbol-header {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 15px;
    .futbol-header-team {
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding-top: 22px;
      width: 180px;
      ${breakpoints.phone} {
        gap: 26px;
        width: 30%;
        padding-top: 28px;
      }
      .futbol-team-img {
        width: 80px;
        height: 80px;
        margin: 0;
        ${breakpoints.phone} {
          width: 50px;
          height: 50px;
        }
        img {
          max-width: 100%;
          width: 100%;
        }
      }
      .futbol-team-name {
        ${Font.sansRegular}
        font-size: 26px;
        line-height: 21px;
        color: ${Color.grey};
        ${breakpoints.phone} {
          font-size: 18px;
        }
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color: ${ColorDark.textLight};
          }
        }
      }
    }
    .local {
      align-items: flex-end;
      ${breakpoints.phone} {
        align-items: center;
      }
      .futbol-team-name {
        text-align: right;
        ${breakpoints.phone} {
          text-align: center;
        }
      }
    }
    .visit {
      align-items: flex-start;
      ${breakpoints.phone} {
        align-items: center;
      }
      .futbol-team-name {
        text-align: left;
        ${breakpoints.phone} {
          text-align: center;
        }
      }
    }
    .futbol-header-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 30px;
      margin-top: 50px;
      width: 25%;
      ${breakpoints.phone} {
        margin-top: 20px;
        width: 33%;
      }
      .futbol-header-info-text {
        ${Font.sansRegular}
        font-size: 14px;
        line-height: 20px;
        color: ${Color.grey};
        text-transform: uppercase;
        text-align: center;
        ${breakpoints.phone} {
          font-size: 11px;
        }
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color: ${ColorDark.textLight};
          }
        }
      }
      .futbol-header-info-details {
        width: 130px;
        height: 73px;
        display: flex;
        align-items: center;
        justify-content: center;
        ${breakpoints.phone} {
          width: 95px;
          height: 40px;
        }
        p {
          ${Font.sansBold}
          font-size: 40px;
          line-height: 35px;
          color: ${Color.white};
          padding-top: 5px;
          ${breakpoints.phone} {
            font-size: 30px;
          }
        }
        .futbol-header-info-time {
          width: 100%;
          background-color: ${Color.grey};
          border-radius: 5px;
          text-align: center;
          padding: 8px;
          padding-top: 11px;
          ${breakpoints.phone} {
            padding: 6px;
            padding-top: 8px;
          }
        }
        .futbol-header-info-goals {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          .futbol-header-info-local,
          .futbol-header-info-visit {
            width: 50%;
            background-color: ${Color.black000};
            border-radius: 5px;
            text-align: center;
            /* padding: 16px; */
            height: 65px;
            display: flex;
            justify-content: center;
            align-items: center;
            ${breakpoints.phone} {
              padding: 6px 0px;
            }
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              background-color: ${Color.grey};
              }
            }
          }
          .played {
            background-color: ${Color.grey};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              background-color: ${ColorDark.darkGrey};
              }
            }
          }
        }
      }
    }
  }

  .futbol-details {
    width: 100%;
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    ${breakpoints.phone} {
      margin-top: 25px;
    }
    .futbol-details-header {
      p {
        ${Font.sansRegular}
        font-size: 12px;
        line-height: 22px;
        color: ${Color.grey};
        padding-bottom: 10px;
        ${breakpoints.phone} {
          padding-top: 5px;
        }
      }
    }
    .futbol-details-info {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      width: 100%;
      .futbol-details-goals {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        gap: 15px;
        .futbol-details-goals-local,
        .futbol-details-goals-visit {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: flex-start;
          padding-right: 15px;
          width: 40%;
          ${breakpoints.phone} {
            padding-right: 0;
          }
          .futbol-details-goals-text {
            text-align: right;
            ${Font.sansRegular}
            font-size: 14px;
            line-height: 24px;
            color: ${Color.black000};
            ${breakpoints.phone} {
              font-size: 12px;
            }
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.textLight};
              }
            }
          }
          .played {
            color: ${Color.grey};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.textLight};
              }
            }
          }
        }
        .futbol-details-goals-visit {
          align-items: flex-start;
          padding-left: 15px;
          ${breakpoints.phone} {
            padding-left: 0;
          }
          .futbol-details-goals-text {
            text-align: left;
          }
        }
      }
      .futbol-details-previous {
        display: flex;
        gap: 12px;
        span {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          ${breakpoints.phone} {
            gap: 6px;
          }
          .futbol-details-previous-result {
            ${Font.sansRegular}
            font-size: 12px;
            line-height: 22px;
            color: ${Color.grey};
          }
        }
      }
      .futbol-details-line {
        height: 46px;
        border-left: 2px dotted ${Color.grey};
        opacity: 0.5;
      }
    }
  }
`;

export const DotResults = styled.div`
  background-color: ${(props) =>
    props.$result === "V"
      ? "#46BE1A"
      : props.$result === "D"
      ? "#F28A5B"
      : Color.grey};
  width: 18px;
  height: 18px;
  border-radius: 50%;
`;
